import React from "react";
import Contact from "../components/Contact/Contact";
import Layout from "../components/Layout";
import Seo from "../components/Seo";

const ContactPage = () => {
  return (
    <Layout>
      <Seo title="Contact" description="If you have any questions, concerns or issues, we're here to help. Check here to find the answers to your questions here and get in touch with us if you need to."/>
      <Contact />
    </Layout>
  );
};

export default ContactPage;
